module.exports = __webpack_public_path__ + "img/book.4fa9f61c.png";